import React from 'react';
import { IconBase } from '../Base';
export const IconBlank = (props) => {
    return (React.createElement(IconBase, { ...props },
        React.createElement("path", { d: "M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z", fill: "none", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", style: { stroke: 'var(--icon-color)' } })));
};
//# sourceMappingURL=Blank.js.map